import { useCallback } from 'react';
import { analytics } from '../utils/analytics';

export function useTracking(componentName: string) {
    const trackCustom = useCallback((name: string, additionalData: Record<string, any> = {}) => {
        analytics.captureAction('custom', componentName, name, additionalData);
    }, [componentName]);

    const trackClick = useCallback((controlName: string, additionalData: Record<string, any> = {}) => {
        analytics.captureAction('click', componentName, controlName, additionalData);
    }, [componentName]);

    const trackChange = useCallback((controlName: string, value: any, additionalData: Record<string, any> = {}) => {
        analytics.captureAction('change', componentName, controlName, {
            value: value,
            ...additionalData
        });
    }, [componentName]);

    const trackSubmit = useCallback((formName: string, formData: Record<string, any> = {}) => {
        analytics.captureAction('submit', componentName, formName, {
            formData: formData
        });
    }, [componentName]);

    const trackError = useCallback((error: Error, context: Record<string, any> = {}) => {
        analytics.captureException(error, {
            type: 'component_error',
            component: componentName,
            ...context
        });
    }, [componentName]);

    return {        
        trackClick,
        trackChange,
        trackSubmit,
        trackError,
        trackCustom,
    };
}